export function IcecreamIllustration({
  className,
  props,
}: {
  className?: string;
  props?: React.SVGProps<SVGSVGElement>;
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='128'
      height='128'
      fill='none'
      viewBox='0 0 128 128'
      className={className}
      aria-hidden='true'
      focusable='false'
      {...props}
    >
      <path
        fill='#1A1A1A'
        fillOpacity='.08'
        d='M64 112c26.51 0 48-21.49 48-48S90.51 16 64 16 16 37.49 16 64s21.49 48 48 48Z'
      />
      <path
        fill='#FFD2A9'
        fillRule='evenodd'
        d='M93.694 77.017c3.419 5.998 6.534 13.728 5.623 20.758-.809 6.234-5.02 10.486-11.049 11.976-11.344 2.802-23.747 2.101-35.363 2.369-12.386.285-24.98-.302-36.883-4.024-2.805-.877-6.853-1.993-5.94-5.872.437-1.855 1.999-3.283 3.745-4.05 2.86-1.257 6.144-.834 8.946-2.286 3.38-1.75 3.77-4.608 3.488-7.98-.924-11.02 3.99-20.957 13.068-27.228.95-.656 1.908-1.32 2.684-2.174 1.268-1.397 1.945-3.186 3.632-4.108 1.865-1.02 3.508-2.349 5.455-3.264 3.9-1.832 8.195-2.82 12.505-2.82 8.807 0 17.29 4.047 22.84 10.883 1.623 1.948 2.841 4.13 3.526 6.577.314 1.122.452 2.282.752 3.403.317 1.19 1.12 2.18 1.411 3.374.142.586.14 1.198.275 1.785.175.765.576 1.457.97 2.136.106.181.211.363.315.545'
        clipRule='evenodd'
      />
      <path
        fill='#FFA926'
        fillRule='evenodd'
        d='m66.388 67.04-25.99-7.167 22.557-31.091L83.442.548c.717-.99 2.277-.56 2.387.658l3.117 34.744 3.432 38.258-25.99-7.167Z'
        clipRule='evenodd'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='m42.008 95.835 1.472 2.55-7.65 4.417-1.473-2.55 7.651-4.417ZM62.57 78.98l-2.064 2.1-6.3-6.193 2.065-2.1 6.3 6.194Z'
        clipRule='evenodd'
      />
      <path
        fill='#FF620F'
        fillRule='evenodd'
        d='m72.77 95.103 2.136 2.028-6.086 6.403-2.135-2.028 6.086-6.403Z'
        clipRule='evenodd'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M60.759 92.095a2.208 2.208 0 1 1-4.417 0 2.208 2.208 0 0 1 4.417 0M82.847 81.063a2.208 2.208 0 1 1-4.417 0 2.208 2.208 0 0 1 4.417 0M87.206 100.03a2.209 2.209 0 1 1-4.417-.001 2.209 2.209 0 0 1 4.417.001'
        clipRule='evenodd'
      />
      <path
        fill='#FF620F'
        fillRule='evenodd'
        d='M42.816 78.867a2.208 2.208 0 1 1-4.417.001 2.208 2.208 0 0 1 4.417 0'
        clipRule='evenodd'
      />
    </svg>
  );
}
